module.exports = __webpack_public_path__ + "img/down-arrow2.119cdb0a.svg";